<!--车辆、工地侧滑-->
<template>
    <div class="actionsPanel">
        <div class="search-custom">
            <div class="search-input">
                <span :class="{'adress-icon':true,'active':searchType==1}" @click="changeSearchType(1)"></span>
                <span class="splitline"></span>
                <span class="car-icon iconfont iconshuiniche" :class="{'active':searchType==2}" @click="changeSearchType(2)"></span>
                <span class="splitline"></span>
                <el-amap-search-box
                    v-show="searchType==1"
                    class="search-box"
                    :search-option="searchOption"
                    :on-search-result="onSearchResult"
                ></el-amap-search-box>
                <input v-show="searchType==2" v-model="searchVal" placeholder="车号/车牌号">
                <span class="search-icon iconfont iconsousuo" @click="handleSearch"></span>
            </div>
            <div class="tab-box">
                <div :class="['tab-item','site-item',showTab=='site'?'active':''] " @click="changeShowTab('site')"></div>
                <div :class="['tab-item','car-item',showTab=='car'?'active':''] " @click="changeShowTab('car')"></div>
            </div>
        </div>
        <div class="slider-box van-slide-right">
            <!-- 工地侧滑-->
            <div class="site-silder slider-wrapper" v-show="showTab=='site'">
                <div :class="{'slider-item':true,active:constructionActive===0}" @click="changeSiteStatus(0)">
                    <label>运输中</label><span>{{ projectsStatistics.trans }}</span>
                </div>
                <div :class="{'slider-item':true,active:constructionActive===1}" @click="changeSiteStatus(1)">
                    <label>未完成</label><span>{{ projectsStatistics.notFinished }}</span>
                </div>
                <div :class="{'slider-item':true,active:constructionActive===2}" @click="changeSiteStatus(2)">
                    <label>未运输</label><span>{{ projectsStatistics.notWork }}</span>
                </div>
            </div>
            <!-- 车辆侧滑-->
            <div class="car-slider slider-wrapper" v-show="showTab=='car'">
                <div :class="{'slider-item':true,active:carActive===0}" @click="changeCarStatus(0)">
                    <label>运输中</label><span>{{ carStatistics.trans }}</span>
                </div>
                <div :class="{'slider-item':true,active:carActive===1}" @click="changeCarStatus(1)">
                    <label>返场中</label><span>{{ carStatistics.back }}</span>
                </div>
                <div :class="{'slider-item':true,active:carActive===2}" @click="changeCarStatus(2)">
                    <label>在工地</label><span>{{ carStatistics.onSite }}</span>
                </div>
                <div :class="{'slider-item':true,active:carActive===3}" @click="changeCarStatus(3)">
                    <label>未运输</label><span>{{ carStatistics.notWork }}</span>
                </div>
            </div>
            <div class="ant-line-btn" @click="showAnt=true">
                蚂蚁线<i class="iconfont iconshuangjiantouxia"></i>
            </div>
        </div>
        <van-action-sheet
            class="ant-pop"
            v-model="showAnt"
            title="蚂蚁线"
        >
            <van-search
                v-model="antSearch"
                placeholder="请输入搜索信息"
                left-icon=""
                right-icon="search"
                @search="handleSearchAntline"
            ></van-search>
            <div :class="{'ant-list':true,haveBackCar:showTab=='car'}">
                <ul>
                    <li
                        :class="{'active': activeWorkOrder===item.task_number}"
                        v-for="(item, index) in workOrderList"
                        :key="item.task_number"
                        @click="clickWorkOrder(item.task_number)"
                    >
                        <h4>
                            <span class="order-num">{{ index+1 }}</span>
                            <span>{{ item.task_number }}；</span>
                            <span
                                class="project_name"
                                :title="item.project_name"
                                v-if="item.project_name"
                            >{{ handleProjectName(item.project_name) }}；</span>
                            <span v-if="item.place">{{ item.place }}；</span>
                            <span v-if="item.strength_grade">{{ item.strength_grade }}；</span>
                            <span>{{ item.grand_total_quantity }}</span>
                        </h4>
                        <div class="line-con">
                            <div>
                                <i class="start-icon"></i>
                                <i class="end-icon"></i>
                                <span class="start-num">0km</span>
                                <span class="middle-num"> {{ item.half_haul_distance }}km</span>
                                <span class="end-num">{{ item.haul_distance_show }}km</span>
                                <template
                                    v-for="(car) in item.cars"
                                >
                                    <div
                                        :class="getClass(car)"
                                        :style="{left:computeDis(item,car)+'%',
                                                 marginLeft: parseInt(computeDis(item,car))!=0?'-15px':'3px'}"
                                        :key="`${item.project_code + car.plate_small_number}`"
                                        v-if="car.orientation===0&&(car.status===1||car.status===4||car.status===5||car.status===6)"
                                    >
                                        {{ car.plate_small_number }}
                                    </div>
                                    <div
                                        :class="getClass(car)"
                                        :style="{right:computeDis(item,car)+'%',
                                                 marginRight: parseInt(computeDis(item,car))!=0?'-15px':'3px'}"
                                        :key="`${item.project_code + car.plate_small_number}`"
                                        v-if="car.orientation===1&&(car.status===1||car.status===4||car.status===5||car.status===6)"
                                    >
                                        {{ car.plate_small_number }}
                                    </div>
                                </template>
                            </div>
                            <div>
                                <template v-for="(car, carindex) in item.cars">
                                    <span
                                        :class="getClass(car)"
                                        v-if="car.status===2||car.status===3"
                                        :key="`${car.plate_number}${carindex}`"
                                    >{{ car.plate_small_number }}</span>
                                </template>
                            </div>
                            <div>
                                <div class="parent">
                                    <div class="per" :style="{height: getFinishInner(item)}"></div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="bottom-scale">
                <div class="title">
                    <span class="left"></span>
                    <span>车辆返场</span>
                    <span class="right"></span>
                </div>
                <div class="scale-con" v-show="showTab=='car'">
                    <div class="scale">
                        <span
                            v-for="(item, index) in scaleArr"
                            :key="`scale_${index}`"
                            :class="{'height8':item%5===0, 'height10':item%10===0}"
                        >
                            <i class="number" v-if="item%10===0">
                                <template v-if="item!==60">
                                    {{ item/2 }}
                                </template>
                                <template v-else>
                                    ...
                                </template>
                            </i>
                        </span>
                        <template v-for="(item, index) in carList">
                            <div
                                :class="getCarClass(item)"
                                :key="`car_${index}`"
                                :style="getCarLeft(item)"
                            >
                                <i class="iconfont iconshuiniche"></i>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="legends">
                    <div class="item item0">
                        <span class="pre-icon"></span>
                        <span>运输中</span>
                    </div>
                    <div class="item item1">
                        <span class="pre-icon"></span>
                        <span>返场中</span>
                    </div>
                    <div class="item item2">
                        <span class="pre-icon"></span>
                        <span>停止</span>
                    </div>
                    <div class="item item3">
                        <span class="pre-icon"></span>
                        <span>卸料</span>
                    </div>
                    <div class="item item4">
                        <span class="pre-icon"></span>
                        <span>在工地</span>
                    </div>
                    <div class="item item5">
                        <span class="pre-icon"></span>
                        <span>无信号</span>
                    </div>
                </div>
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import { eventBus } from '@/common/eventBus.ts';
export default {
    name: 'actions-panel',
    props: {
        projectsStatistics: {
            type: Object,
        },
        carStatistics: {
            type: Object,
        },
        stationId: {
            type: String,
        },
    },
    data() {
        return {
            searchType: 2, // 搜索类型 1:位置搜索，2：车号车牌搜索
            showTab: 'site', // 显示的栏，site：工地，car:车辆
            carActive: -1, // 车辆选中状态
            constructionActive: 0, // 工地选中状态

            searchOption: {
                city: '全国',
                citylimit: true,
            },
            searchVal: '', // 搜索

            showAnt: false, // 显示蚂蚁线
            antSearch: '', // 蚂蚁线搜索
            workOrderList: [], // 蚂蚁线
            activeWorkOrder: '',
            scaleArr: [],
            carList: [],
        };
    },
    mounted() {
        this.tenantId = this.$takeTokenParameters('TenantId');
        eventBus.$on('TaskLineChangeMsg', data => {
            if (data.tenant_id === this.tenantId && data.mixstation_code === this.stationId) {
                this.taskLineChange(data);
            }
        });
        eventBus.$on('MapCarChangeMsg', data => {
            if (data.tenant_id === this.tenantId && data.mixstation_code === this.stationId) {
                this.mapCarChange(data);
            }
        });
        this.init();
    },
    watch: {
        // 搜索变动
        keword(val) {
            this.$emit('searchChange', val, this.searchType);
        },
    },
    methods: {
        // 位置搜索
        onSearchResult(pois) {
            this.$parent.onSearchResult(pois);
        },
        // 车牌号搜索
        handleSearch() {
            this.$parent.getLocation(this.searchVal);
        },
        // 改变搜索类型
        changeSearchType(state) {
            this.searchType = state;
        },
        // 改变车辆状态
        changeCarStatus(state) {
            if (this.carActive === state) {
                this.carActive = -1;
                this.$emit('carClick', '');
            } else {
                this.carActive = state;
                this.$emit('carClick', state);
            }
            this.$emit('closeInfoWindow');
            this.activeWorkOrder = '';
            this.handleProductionList();
        },
        // 改变工地状态
        changeSiteStatus(state) {
            this.constructionActive = state;
            this.$emit('projectsClick', state);
            this.$emit('closeInfoWindow');
            this.activeWorkOrder = '';
            this.handleProductionList();
            this.$parent.getLocation();
        },
        changeShowTab(tag) {
            this.showTab = tag;
        },

        init() {
            // 底部刻度线初始化渲染
            for (let i = 0; i <= 60; i++ ) {
                this.scaleArr.push(i);
            }
            this.handleProductionList();
        },
        // 蚂蚁线工程名称截取
        handleProjectName(val) {
            let str = '';
            if (val) {
                if (val.length > 12) {
                    str = val.substr(0, 12) + '...';
                }
            }
            return str;
        },
        // 蚂蚁线查询
        handleSearchAntline() {
            this.handleProductionList();
        },
        // 处理蚂蚁线数据
        async handleProductionList() {
            let res = [];
            if (this.showTab === 'site') {
                res = await this.getProductionList();
            } else {
                res = await this.getProductionListCar();
            }
            if (res) {
                this.workOrderList = res.splice(0, 30);
                let taskNumbers = '';
                this.workOrderList.map((item, index) => {
                    taskNumbers += item.task_number + ',';
                    // eslint-disable-next-line radix
                    item.haul_distance_show = (item.haul_distance / 1000).toFixed(2);
                    item.half_haul_distance = (item.haul_distance / 2 / 1000).toFixed(2);
                    if (item.project_type === '103-FJ0') {
                        item.project_name = item.project_name + '| ' + item.monomer_name;
                    }
                    if (item.product_status !== 2) {
                        this.workOrderList.splice(index, 1);
                    }
                });
                this.carList = [];
                if (taskNumbers) {
                    const cars = await this.getTaskCars(taskNumbers);
                    if (cars) {
                        const map = {};
                        for (let i = 0; i < cars.length; i++) {
                            const ai = cars[i];
                            // eslint-disable-next-line max-depth
                            if (!map[ai.task_number]) {
                                map[ai.task_number] = [];
                                // eslint-disable-next-line max-depth
                                if (ai.status === 0 || ai.status === 10) {
                                    // map[ai.task_number] = [];
                                } else if (this.carActive === 0) {
                                    // eslint-disable-next-line max-depth
                                    if (ai.status !== 1) {
                                        map[ai.task_number].push(ai);
                                    } else {
                                        this.carList.push(ai);
                                    }
                                } else if (this.carActive === 1) {
                                    // eslint-disable-next-line max-depth
                                    if (ai.status !== 4) {
                                        map[ai.task_number].push(ai);
                                    } else {
                                        this.carList.push(ai);
                                    }
                                } else {
                                    map[ai.task_number].push(ai);
                                }
                            } else {
                                // eslint-disable-next-line no-lonely-if max-depth
                                // eslint-disable-next-line
                                if (ai.status === 0 || ai.status === 10) {
                                    // map[ai.task_number] = [];
                                } else if (this.carActive === 0) {
                                    // eslint-disable-next-line max-depth
                                    if (ai.status !== 1) {
                                        map[ai.task_number].push(ai);
                                    } else {
                                        this.carList.push(ai);
                                    }
                                } else if (this.carActive === 1) {
                                    // eslint-disable-next-line max-depth
                                    if (ai.status !== 4) {
                                        map[ai.task_number].push(ai);
                                    } else {
                                        this.carList.push(ai);
                                    }
                                } else {
                                    map[ai.task_number].push(ai);
                                }
                            }
                        }
                        this.workOrderList = this.workOrderList.map(item => {
                            if (map[item.task_number]) {
                                item.cars = map[item.task_number];
                            } else {
                                item.cars = [];
                            }
                            return item;
                        });
                    }
                }
            }
        },
        // 车辆状态
        getClass(data) {
            let str = 'car';
            if (data.orientation === 0) {
                str += ' to-car';
            } else {
                str += ' back-car';
            }
            switch (data.status) {
                case 1:
                    str += ' trans-car';
                    break;
                case 2:
                    str += ' arrive-car';
                    break;
                case 3:
                    str += ' discharge-car';
                    break;
                case 4:
                    str += ' return-car';
                    break;
                case 5:
                    str += ' stop-car';
                    break;
                case 10:
                    str += ' finish-car';
                    break;
                default:
            }
            return str;
        },
        // 计算车辆位置
        computeDis(item, car) {
            let dis = 0;
            if (car.orientation === 0) {
                if (car.to_distance <= item.haul_distance) {
                    dis = (car.to_distance / item.haul_distance * 100).toFixed(2);
                } else {
                    dis = 95;
                }
            } else if (car.orientation === 1) {
                if (car.back_distance <= item.haul_distance) {
                    dis = (car.back_distance / item.haul_distance * 100).toFixed(2);
                } else {
                    dis = 5;
                }
            }
            return dis;
        },
        // 完成率
        getFinishInner(data) {
            let finishRate = 0;
            if (data.plan_quantity) {
                let rate = (data.grand_total_quantity / data.plan_quantity * 100).toFixed(2);
                if (rate > 100) {
                    rate = 100;
                }
                finishRate = rate + '%';
            }
            return finishRate;
        },
        // 车辆返场-距离终点距离
        getCarLeft(data) {
            let styleStr = { left: 0, marginLeft: 0 };
            let rate = 0;
            rate = (Number(data.target_distance) / 30).toFixed(2);
            if (Number(rate) === 0) {
                styleStr = { left: rate * 100 + '%', marginLeft: '6rpx' };
            } else if (Number(rate) >= 100) {
                rate = '100%';
                styleStr = { left: '100%', marginLeft: '-6rpx' };
            } else {
                styleStr = { left: rate * 100 + '%', marginLeft: '-6rpx' };
            }
            return styleStr;
        },
        // 车辆返场-车辆状态
        getCarClass(data) {
            let str = 'car';
            if (data.status === 1) {
                str += '  car-trans';
            } else if (data.status === 4) {
                str += ' car-back';
            }
            return str;
        },
        // 点击蚂蚁线显示地图车辆
        async clickWorkOrder(task_number) {
            this.activeWorkOrder = task_number;
            const res = await this.getAntLineCars();
            if (res) {
                const markersArr = [];
                res.forEach((item, index) => {
                    if (item.status !== 9) {
                        let markersObj = {};
                        if (item.longitude && item.latitude) {
                            // 车辆信息
                            markersObj = {
                                carName: item.plate_number,
                                plate_small_number: item.plate_small_number,
                                position: [item.longitude, item.latitude],
                                numberOffset: [],
                                content: this.$parent.getContentHtml(item),
                                icon: require('../../../assets/images/productionManagement/red.png'),
                                events: {
                                    click: () => {
                                        this.$parent.switchWindow(index, item, markersObj.position);
                                    },
                                },
                                visible: false,
                                type: '',
                                status: item.status,
                            };

                            if ([6].indexOf(item.status) > -1) {
                                markersObj.type = 'trans';
                            } else if ([7, 73].indexOf(item.status) > -1) {
                                markersObj.type = 'onSite';
                            } else if ([77, 8].indexOf(item.status) > -1) {
                                markersObj.type = 'back';
                            } else if ([1, 2, 21, 3, 31, 4, 5].indexOf(item.status) > -1) {
                                markersObj.type = 'notWork';
                            }
                            markersArr.push(markersObj);
                        }
                    }
                });
                this.$parent.oldCars = JSON.parse(JSON.stringify(markersArr));
                this.$parent.markers = markersArr;
            }
        },

        // 任务单改变
        async taskLineChange(data) {
            // 生产状态 0 未排 1 待生产2 生产中 3 已完成 4 暂停 5 已关闭 6 已取消
            // 只更新生产中的
            const res = this.workOrderList.filter(item => item.task_number === data.task_number);
            if (data.station === this.currentStationId) {
                if (data.product_status === 2) {
                    if (res.length > 0) {
                        this.workOrderList = this.workOrderList.map(item => {
                            if (data.task_number === item.task_number) {
                                const cars = JSON.parse(JSON.stringify(item)).cars;
                                item = data;
                                item.haul_distance_show = (data.haul_distance / 1000).toFixed(2);
                                item.half_haul_distance = (data.haul_distance / 2 / 1000).toFixed(2);
                                item.cars = cars;
                            }
                            return item;
                        });
                    } else {
                        data.haul_distance_show = (data.haul_distance / 1000).toFixed(2);
                        data.half_haul_distance = (data.haul_distance / 2 / 1000).toFixed(2);
                        const cars = await this.getTaskCars(data.task_number);
                        if (cars) {
                            data.cars = cars;
                            this.workOrderList.push(data);
                        } else {
                            data.cars = [];
                            this.workOrderList.push(data);
                        }
                    }

                } else {
                    this.workOrderList.map((item, index) => {
                        if (data.task_number === item.task_number) {
                            this.workOrderList.splice(index, 1);
                        }
                    });
                }
            }
        },
        // 车辆状态改变
        mapCarChange(data) {
            // 0 默认、1运输中、2到达 3 卸料、4 返场、 5 停止、6 未知、10 完成
            let findIndex = -1;
            this.workOrderList.map(item => {
                if (item.cars) {
                    item.cars.map((v, vIndex) => {
                        if (v.plate_number === data.plate_number) {
                            findIndex = 0;
                        }
                    });
                }
                this.carList.map(item => {
                    if (item.plate_number === data.plate_number) {
                        findIndex = 0;
                    }
                });
            });
            if (findIndex === -1) {
                if (data.task_number) {
                    this.workOrderList = this.workOrderList.map(item => {
                        if (item.task_number === data.task_number) {
                            if (data.status !== 0 && data.status !== 10) {
                                if (this.carActive === 0) {
                                    if (data.status !== 1) {
                                        item.cars.push(data);
                                    } else {
                                        this.carList.push(data);
                                    }
                                } else if (this.carActive === 1) {
                                    if (data.status !== 4) {
                                        item.cars.push(data);
                                    } else {
                                        this.carList.push(data);
                                    }
                                } else {
                                    item.cars.push(data);
                                }
                            }
                        }
                        return item;
                    });
                }
            } else if (data.status === 0 && data.status === 10) {
                this.workOrderList = this.workOrderList.map(item => {
                    if (item.cars) {
                        item.cars.map((v, vIndex) => {
                            if (v.plate_number === data.plate_number) {
                                item.cars.splice(vIndex, 1);
                            }
                        });
                    }

                    return item;
                });
                this.carList.map((item, index) => {
                    if (item.plate_number === data.plate_number) {
                        this.carList.splice(index, 1);
                    }
                });
            } else {
                this.workOrderList = this.workOrderList.map(item => {
                    if (item.cars) {
                        item.cars = item.cars.map(v => {
                            if (v.plate_number === data.plate_number) {
                                v = data;
                            }
                            return v;
                        });
                    }
                    return item;
                });
                this.carList = this.carList.map(item => {
                    if (item.plate_number === data.plate_number) {
                        item = data;
                    }
                    return item;
                });
            }
        },
        // 拉取运输中车辆
        getTaskCars(taskNumbers) {
            return this.$axios.get('/interfaceApi/production/producttask/get_task_cars?task_number=' + taskNumbers);
        },
        // 拉取在施工地蚂蚁线
        getProductionList() {
            const path = '/interfaceApi/production/producttask/get_production_list?stationCode='
                + this.stationId + '&product_status=' + this.constructionActive + '&keywords=' + this.antSearch;
            return this.$axios.$get(path, { defEx: true });
        },
        // 拉取运输车辆-蚂蚁线
        getProductionListCar() {
            const path = '/interfaceApi/production/producttask/get_production_list_car?stationCode='
                + this.stationId + '&car_status=' + this.carActive + '&keywords=' + this.antSearch;
            return this.$axios.$get(path, { defEx: true });
        },
        // 拉取蚂蚁线下地图车辆
        getAntLineCars() {
            const carType = 0;
            const path = '/interfaceApi/production/vehicleinfo/get_location?stationId='
                + `${this.stationId}&carType=${carType}&keywords=${this.$parent.searchInfo}&task_number=${this.activeWorkOrder}`;
            return this.$axios.$get(path, { defEx: true });
        },
    },
    beforeDestroy() {
        eventBus.$off('TaskLineChangeMsg');
        eventBus.$off('MapCarChangeMsg');
    },
};
</script>

<style lang="stylus" scoped>
@font-face
    font-family technology
    src url('../../../assets/fonts/font/technology.ttf')
.actionsPanel
    .search-custom
        width 95%;
        height 50rpx;
        position: absolute;
        top 48rpx;
        left 0
        right 0;
        margin 0 auto
        background #fff;
        padding 10rpx;
        padding-right 5rpx
        display flex
        justify-content space-between
        align-items center
        z-index 9
        .search-input
            width 255rpx;
            height 30rpx;
            background #F3F4F6
            border-radius: 4rpx;
            border: 1px solid #ECECEE;
            display flex
            justify-content space-between
            align-items center
            input
                width 150rpx
                height 100%
                background transparent
                border 0
                font-size 12rpx;
                padding-left 5rpx;
            .splitline
                width 1px
                height 10rpx
                background #D7D7D7
            .car-icon
                margin 0 5rpx;
                color #666
                font-size 20rpx;
                &.active
                    color #1577D2
            .adress-icon
                margin 0 5rpx;
                width 20rpx
                height 16rpx
                background url("../../../assets/images/logisticsMonitoring/icon1_normal.png")
                background-size 100% 100%;
                &.active
                    background url("../../../assets/images/logisticsMonitoring/icon1_highlight.png")
                    background-size 100% 100%;
            .search-icon
                margin-left -10rpx;
                margin-right 10rpx;
                font-size 14rpx;
        .tab-box
            flex 1
            display flex
            justify-content space-between
            align-items center
            padding-left 10rpx;
            padding-top 1px
            .tab-item
                width: 37rpx;
                height: 37rpx;
                /*border-radius: 4rpx;*/
                &.site-item
                    background url("../../../assets/images/logisticsMonitoring/icon13_normal.png") center
                    background-size 100%;
                    &.active
                        background url("../../../assets/images/logisticsMonitoring/icon13_highlight.png") center
                        background-size 100%;
                &.car-item
                    background url("../../../assets/images/logisticsMonitoring/icon14_normal.png") center
                    background-size 100%;
                    &.active
                        background url("../../../assets/images/logisticsMonitoring/icon14_highlight.png") center
                        background-size 100%;
    .slider-box
        width 80rpx;
        position absolute
        right 3%;
        top 100rpx;
        z-index 9
        .slider-wrapper
            width 100%;
            display flex
            flex-direction column
            background #132F55
            position relative
            .slider-item
                width 100%
                height 60rpx;
                display flex
                flex-direction column
                justify-content center
                padding 0 14rpx;
                padding-top 8rpx;
                border-bottom 1px solid rgba(0,0,0,0.3)
                label
                    font-size 12rpx;
                    color #fff;
                span
                    font-size 24rpx;
                    font-family: Technology-Regular, Technology;
        .site-silder
            &:before
                display inline-block
                content ''
                width 0
                height 0
                border-width 0 8rpx 8rpx
                border-style solid
                border-color transparent transparent #132F55
                position absolute
                top -8rpx;
                left 10rpx;
            .slider-item
                &:nth-child(1)
                    color #6DD400
                    &.active
                        box-shadow: 0px 0px 12rpx 2rpx #6DD400 inset;
                &:nth-child(2)
                    color #32C5FF
                    &.active
                        box-shadow: 0px 0px 12rpx 2rpx #32C5FF inset;
                &:nth-child(3)
                    color #FF5757
                    &.active
                        box-shadow: 0px 0px 12rpx 2rpx #FF5757 inset;
        .car-slider
            &:before
                display inline-block
                content ''
                width 0
                height 0
                border-width 0 8rpx 8rpx
                border-style solid
                border-color transparent transparent #132F55
                position absolute
                top -8rpx;
                right 13rpx;
            &.active1:before
                border-color transparent transparent #32C5FF
            .slider-item
                &:nth-child(1)
                    color #32C5FF
                    &.active
                        box-shadow: 0px 0px 12rpx 2rpx #32C5FF inset;
                &:nth-child(2)
                    color #F7B500
                    &.active
                        box-shadow: 0px 0px 12rpx 2rpx #F7B500 inset;
                &:nth-child(3)
                    color #6DD400
                    &.active
                        box-shadow: 0px 0px 12rpx 2rpx #6DD400 inset;
                &:nth-child(4)
                    color #FF5757
                    &.active
                        box-shadow: 0px 0px 12rpx 2rpx #FF5757 inset;
        .ant-line-btn
            width 100%
            height: 44rpx;
            background: #1890FF;
            border-radius: 0px 0px 4rpx 4rpx;
            display flex
            justify-content center
            align-items center
            font-size 14rpx;
            color #fff;
    .el-vue-search-box-container
        width 150rpx;
        height 30rpx
        border-radius unset
        box-shadow none
        background transparent
        >>> .search-btn
            opacity 0;
        >>> input
            width 140rpx;
            background transparent
    .ant-pop
        min-height 485rpx;
        .van-search
            background #fff!important;
            .van-search__content
                background #F3F4F6!important;
        .ant-list
            margin-top 10rpx
            height 300rpx;
            overflow-y auto
            &.haveBackCar
                height 275rpx
            li
                margin 0 auto;
                width 96%
                padding 10rpx
                box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.3);
                border-radius: 4rpx;
                border: 1px solid #D7D7D7;
                margin-bottom 10rpx
                color #333333
                font-size 12rpx
                cursor pointer
                .order-num
                    width 15rpx
                    height 15rpx
                    text-align center
                    line-height 15rpx
                    display inline-block
                    background #01A675
                    color #fff
                    border-radius 50%
                    margin-right 5rpx
                .line-con
                    display flex
                    justify-content space-between
                    padding-bottom 15rpx
                    margin-top 8rpx
                    >div
                        &:nth-child(1)
                            width 100%
                            border-bottom 1px solid #D7D7D7
                            margin 10rpx 0 5rpx 25rpx
                            position relative
                            margin-right 20rpx
                            .start-icon,.end-icon
                                position absolute
                                background-repeat no-repeat
                                background-size 100% 100%
                                width 30rpx
                                height 30rpx
                                top 0rpx
                            .start-icon
                                top -6rpx
                                left -20rpx
                                background url("../../../assets/images/logisticsMonitoring/cz.png") center
                                background-size 100% 100%;
                            .end-icon
                                height 40rpx
                                top -16rpx
                                right -20rpx
                                background url("../../../assets/images/logisticsMonitoring/qizi-icon.png") center
                                background-size 100% 100%;
                            &:before
                                content ''
                                position absolute
                                width 0
                                height 0
                                border 3rpx solid transparent
                                border-bottom-color #1890FF
                                bottom -5rpx
                                left 50%
                                margin-left -3rpx
                            .start-num,.middle-num,.end-num
                                position absolute
                                top 24rpx
                                color #979EA7
                            .start-num
                                left 0
                            .middle-num
                                left 50%
                                margin-left -10rpx
                            .end-num
                                right -12rpx
                            .car
                                max-width 30rpx;
                                height 20rpx
                                background #0091FF
                                border-radius 2rpx
                                border 1px solid #FFFFFF
                                position absolute
                                left 10rpx
                                text-align center
                                line-height 12rox
                                color #fff;
                                padding 0 2rpx
                                top 15rpx
                            .trans-car
                                top -3rpx;
                                background #0048B8
                            .stop-car
                                background #D6010F
                            .discharge-car
                                background #7B36C9
                            .return-car
                                background #FF7E00
                            .arrive-car
                                background #20AD52
                        &:nth-child(2)
                            width 60rpx
                            overflow hidden
                            margin-top 10rpx
                            margin-left 1px
                            .car
                                float left
                                max-width 30rpx;
                                height 20rpx
                                background #007E00
                                border-radius 2rpx
                                border 1px solid #FFFFFF
                                margin 0 .02rem .02rem 0
                                text-align center
                                color #fff;
                                padding 0 2rpx
                                .trans-car
                                    background #0048B8
                                .stop-car
                                    background #D6010F
                                .discharge-car
                                    background #7B36C9
                                .return-car
                                    background #FF7E00
                                .arrive-car
                                    background #20AD52
                        &:nth-child(3)
                            .parent
                                width 5rpx
                                height 25rpx
                                border 1px solid #65D39C
                                position relative
                                box-sizing border-box
                                margin-top 6rpx
                                background: #CEF5E0;
                                .per
                                    width 4rpx
                                    height 12rpx
                                    background linear-gradient(180deg, #76E0A8 0%, #13BD63 100%)
                                    position absolute
                                    left 0
                                    bottom 0
                &.active
                    border-color #01a675
        .bottom-scale
            position absolute
            bottom 0
            left 0
            width 100%
            .title
                display flex
                height 16rpx
                align-items center
                color #fff
                font-size 12rpx
                background #1890FF
                .left,.right
                    flex 1;
                    border-top 1px dashed #fff
                    margin-top 6rpx
                >span
                    &:nth-child(2)
                        width 60rpx;
                        text-align center
            .scale-con
                height 40rpx
                padding 0 10rpx
                background #fff
                .scale
                    display flex
                    position relative
                    .iconshuiniche
                        font-size 20rpx
                    span
                        width calc(100% / 60)
                        position relative
                        height 4rpx
                        margin-top 4rpx
                        &:after
                            content ''
                            left 0
                            top 0
                            position absolute
                            background #333
                            height 4rpx
                            width 1px
                        &.height8
                            &:after
                                height 8rpx
                        &.height10
                            &:after
                                height 10rpx
                        .number
                            position absolute
                            font-size 12rpx
                            color #333
                            width 30rpx
                            left 10rpx
                            text-align center
                            top 15rpx
                    .car
                        position absolute
                        left 10%
                        top 18rpx;
                        background-repeat no-repeat
                        background-size 100% 100%
                        width 40rpx
                        height 40rpx
                        margin-left -10rpx
                    .car-trans
                        color #0048b8
                    .car-back
                        color #ff7e00
            .legends
                padding 5rpx 8rpx 0 8rpx
                background #F1F1F1
                display flex
                flex-wrap wrap
                .item
                    flex-shrink 0
                    width 20%
                    font-size 12rpx
                    color #333
                    margin-bottom 5rpx
                    .pre-icon
                        width 10rpx
                        height 10rpx
                        background #007E00
                        border 1px solid #fff
                        border-radius 1px
                        display inline-block
                        margin-right 3rpx
                .item0
                    .pre-icon
                        background #0048b8
                .item1
                    .pre-icon
                        background #ff7e00
                .item2
                    .pre-icon
                        background #d6010f
                .item3
                    .pre-icon
                        background #9152d8
                .item4
                    .pre-icon
                        background #20ad52
                .item5
                    .pre-icon
                        background #c8c8c8
</style>
